export const surveyTextFieldsMapSF = {
  Id: 'id',
  Survey_Translation__c: 'surveyTranslationId',
  Text__c: 'text',
  Language__c: 'language',
}

export interface SurveyText {
  id: string
  surveyTranslationId: string
  text: string
  language: string
}
